import Uiconstants from "../../lib/UIconstants";
import { BetAmountArea } from "./BetAmountArea";
import BetAmountController from "../../controllers/BetAmountController";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import { COMPONENTS } from "../../lib/constants";

export const BetAmount = {
  name: COMPONENTS.BET_AMOUNT,
  position: {
    x: 1410,
    y: 710 - 41,
  },
  controllers: [
    {
      Controller: BetAmountController,
      name: "BetAmountController",
      config: {
        name: COMPONENTS.BET_AMOUNT,
        item: COMPONENTS.BET_AMOUNT,
        bets: GameConfigs.config.bet_steps,
        currency: GameConfigs.config.currency,
        btns: [Uiconstants.BTN_MINUS, Uiconstants.BTN_PLUS],
      },
    },
  ],

  components: [
    {
      name: "holder",
      type: "Sprite",
      components: [
        {
          name: "BET_AMOUNT",
          //position: { x: -7, y: -30 },
          position: { x: 0, y: 0 },
          type: "VisualComponent",
          component: BetAmountArea,
        },
        {
          name: Uiconstants.BTN_MINUS,
          type: "ActionButton",
          position: { x: 260, y: 48 },
          scale: {x: 0.9, y: 0.9},
          bg: "decrease_bet_icon",
          bet: true,
        },

        {
          name: Uiconstants.BTN_PLUS,
          type: "ActionButton",
          position: { x: 328, y: 46 },
          scale: {x: 0.9, y: 0.9},
          bg: "increase_bet_icon",
          bet: true,
        },
      ],
    },
  ],
};
